// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"b089e6fb","217":"6be3ee3b","321":"63fad15a","359":"08dbf916","453":"41227df5","490":"ed92eb65","672":"7aa1b078","745":"69f1e395","975":"233e1999"}[chunkId] + ".chunk.js";
};